import React from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import {Button, Col, Drawer, Layout, Menu, Row, Tooltip} from 'antd';
import authorization from "../../../Main/authorization";
import 'antd/lib/layout/style/css';
import 'antd/lib/menu/style/css';
import logo from '../../../../resources/img/logo-dark-ca.png';
import logora from '../../../../resources/img/logo-dark-ra.png';
import './PrivateSider.css';
import {connect} from "react-redux";
import logOut from "../../../../actions/logout";
import changeLanguage from "../../../../actions/changeLanguage";
import {push,replace} from 'connected-react-router';
import languages from "../../../../language/languages";
import {
  ADMIN_ROUTE,
  CERTIFICATE_REQUEST_PKCS10_ROUTE,
  CERTIFICATE_REQUEST_ROUTE, CHANGE_PASSWORD_ROUTE,
  MAIN_ROUTE,
  REPORTS_ROUTE
} from "../../../Main/routes";
import coSvg from "../../../../resources/img/co.svg";
import usSvg from "../../../../resources/img/us.svg";
const {Sider} = Layout;

class PrivateSider extends React.Component {

  state = {
    fixed: false,
    visible:false
  };

  changeFixedSider(brakepoint) {
    this.setState({
      fixed: brakepoint
    });
  }

  showDrawer = () => {
    this.setState({
      visible: !this.state.visible
    });
  };

  handleLanguage = () => {
    this.props.changeLanguage(this.props.language);
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  renderMenu=()=>
  {
    return <div><img className={'sider-logo'} src={this.props.isRA?logora:logo} alt=""/><Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['/']}
        selectedKeys={[this.props.pathname.split('/')[1]]}
        style={{lineHeight: '64px'}}
        onClick={()=>{this.setState({visible:false})}}
    >
      <Menu.Item key={MAIN_ROUTE.split('/')[1]} onClick={() => this.props.replace(MAIN_ROUTE)}
                 disabled={this.props.pathname === MAIN_ROUTE}>
        <i className={'netco-icon'}>B</i> {languages[this.props.language].listCertsLabel}
      </Menu.Item>
      {(this.props.role===1 || this.props.isRA)?<Menu.Item key={CERTIFICATE_REQUEST_ROUTE.split('/')[1]} onClick={() => this.props.push(CERTIFICATE_REQUEST_ROUTE)}
                                                           disabled={this.props.pathname === CERTIFICATE_REQUEST_ROUTE}>
        <i className={'netco-icon'}>A</i> {languages[this.props.language].newCertRequest}
      </Menu.Item>:''}
      {(this.props.role===1 || this.props.isRA)?<Menu.Item key={CERTIFICATE_REQUEST_PKCS10_ROUTE.split('/')[1]} onClick={() => this.props.push(CERTIFICATE_REQUEST_PKCS10_ROUTE)}
                                                           disabled={this.props.pathname === CERTIFICATE_REQUEST_PKCS10_ROUTE}>
        <i className={'netco-icon'}>B</i> {languages[this.props.language].generatePKCS10Request}
      </Menu.Item>:''}
      {this.props.role===1?<Menu.Item key={ADMIN_ROUTE.split('/')[1]} onClick={() => this.props.push(ADMIN_ROUTE)}
                                      disabled={this.props.pathname === ADMIN_ROUTE}>
        <i className={'netco-icon'}>N</i> {languages[this.props.language].adminLabel}
      </Menu.Item>:''}
      <Menu.Item key={REPORTS_ROUTE.split('/')[1]} onClick={() => this.props.replace(REPORTS_ROUTE)}
                 disabled={this.props.pathname === REPORTS_ROUTE}>
        <i className={'netco-icon'}>E</i> {languages[this.props.language].reportsLabel}
      </Menu.Item>
      <Menu.Item key={CHANGE_PASSWORD_ROUTE.split('/')[1]} onClick={() => this.props.replace(CHANGE_PASSWORD_ROUTE)}
                 disabled={this.props.pathname === CHANGE_PASSWORD_ROUTE}>
        <i className={'netco-icon'}>Y</i> {languages[this.props.language].changePassLabel}
      </Menu.Item>
      <Menu.Item className={'float-right'} onClick={this.props.logOut}>
        <i className={'netco-icon'}>I</i> {languages[this.props.language].logout}
      </Menu.Item>
    </Menu></div>
  };

  render() {
    if(this.state.fixed)
      return (
        <div>
          <Row style={{marginLeft:0,marginRight:0}}  gutter={24}>
            <Col span={4} style={{textAlign:'left'}}>
              <Button className={'iconBars'} htmlType={'button'} icon={<LegacyIcon type={'bars'} />}
                      onClick={this.showDrawer}/>
            </Col>
            <Col span={16} style={{textAlign:'center'}}>
              <Tooltip title={this.props.userName}>
              <div style={{color:'black'}}><i className={'netco-icon'}>Y</i></div>
              </Tooltip>
            </Col>
            <Col span={4} style={{textAlign:'right'}}>
              <div onClick={this.handleLanguage} >{this.props.language === 'es' ? <img style={{width: 30}} alt={'COL flag'} src={coSvg}/> : <img style={{width: 30}} alt={'US flag'} src={usSvg}/>}</div>
            </Col>
          </Row>
          <Drawer
              closable={true}
              onClose={this.onClose}
              drawerStyle={{backgroundColor:'#3a3747'}} headerStyle={{backgroundColor:'#3a3747'}} bodyStyle={{backgroundColor:'#3a3747'}} visible={this.state.visible} placement={'left'}>
            {this.renderMenu()}
          </Drawer>
        </div>
      );
    return <Sider
           className={this.state.fixed ? 'ant-layout-sider-fixed' : ''}
           breakpoint="sm"
           collapsedWidth="0"
           onBreakpoint={(broken) => {
             this.changeFixedSider(broken);
           }}>
      {this.renderMenu()}
    </Sider>;
  }

}


function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    logged: state.auth.logged,
    language: state.auth.language,
    userName:state.auth.userName,
    isRA:state.auth.isRA,
    role:state.auth.role
  }
}

export default authorization(connect(mapStateToProps, {logOut, push, replace,changeLanguage})(PrivateSider));
